var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.Lang.locale === _vm.defaultLanguage ? '/cart/' + _vm.cart.orderId: '/' + _vm.Lang.locale + '/cart/'+ _vm.cart.orderId}},[_c('div',{staticClass:"cart-count"},[_vm._v(_vm._s(_vm.cart.getServicesInCart()))])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32046cd9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/order/BtnCart.vue
// module id = bdVv
// module chunks = 2